export default class PainelDetailsController {
  constructor($q, $state, $scope, AuthenticationService, UIService, PainelService, Painel, Abrangencia, Ambito, EntidadeFinanciadora, Investigador) {
    this.$q = $q;
    this.$state = $state;
    this.$scope = $scope;
    this.UI = UIService;
    this.user = AuthenticationService.getUser();
    this.PainelService = PainelService;
    this.loaded = false;

    this.Painel = Painel;
    this.Abrangencia = Abrangencia;
    this.Ambito = Ambito;
    this.EntidadeFinanciadora = EntidadeFinanciadora;
    this.Investigador = Investigador;

    this.showEstadosPanel = false;

    this.loaded = false;

    this.id = $state.params.id;

    this.loadData();
    this.limit = 3;
  }

  limitTo = () => {
    if (angular.isDefined(this.limit)) {
      this.limit = undefined;
    } else {
      this.limit = 3;
    }
  };

  loadData = () => {
    this.loaded = false;
    this.Painel.findOne({
      filter: {
        where: {
          id: this.id
        },
        include: ['criadoPor', 'atualizadoPor', 'abrangencia', 'ambito', 'entidadeFinanciadora', 'investigador']
      }
    }).$promise.then(res => {
      this.data = res;

      this.loaded = true;
    }).catch((error) => {
      console.log(error);
      this.$state.go('app.painel.list');
      this.UI.addToast('Erro ao carregar painel. Verifique a ligação');
    });

  };

  editDetalhes = () => {
    let wait = this.UI.showWaiting();
    this.Investigador.find({}).$promise.then(investigadores => {
      investigadores.sort((a, b) => a.nome.localeCompare(b.nome));
      this.EntidadeFinanciadora.find({}).$promise.then(entidadesFinanciadoras => {
        this.Ambito.find({}).$promise.then(ambitos => {
          this.Abrangencia.find({}).$promise.then((abrangencias) => {
            wait.close();
            let options = {
              size: 'lg',
              template: require('./details.dialog.html'),
              controller: ['$scope', ($scope) => {
                $scope.label = "Editar Painel";
                $scope.isNew = false; // Do not show observacoes when editing
                $scope.painel = angular.copy(this.data);
                $scope.abrangencias = abrangencias;
                $scope.entidadesFinanciadoras = entidadesFinanciadoras;
                $scope.ambitos = ambitos;
                $scope.investigadores = investigadores;

                // Current year as max be able to add ano
                $scope.year = moment().format('YYYY');

                $scope.auxAbrangencia = {
                  selected: $scope.painel.abrangencia ? $scope.painel.abrangencia : null,
                  infiniteScroll: {numToAdd: 20, currentItems: 20}
                };
                $scope.auxAmbito = {
                  selected: $scope.painel.ambito ? $scope.painel.ambito : null,
                  infiniteScroll: {numToAdd: 20, currentItems: 20}
                };
                $scope.auxEntidade = {
                  selected: $scope.painel.entidadeFinanciadora ? $scope.painel.entidadeFinanciadora : null,
                  infiniteScroll: {numToAdd: 20, currentItems: 20}
                };
                $scope.auxInvestigador = {
                  selected: $scope.painel.investigador ? $scope.painel.investigador : null,
                  infiniteScroll: {numToAdd: 20, currentItems: 20}
                };

                // Infinite Scroll magic
                $scope.addMoreItems = (infiniteScroll) => {
                  infiniteScroll.currentItems += infiniteScroll.numToAdd;
                };

                $scope.ok = () => {
                  $scope.$close($scope);
                };

                $scope.cancel = () => $scope.$dismiss('cancel');
              }]
            };

            this.UI.showDialog(options).then(res => {
              this.loaded = false;
              if (res) {
                this.data.ano = res.painel.ano;
                this.data.identificacao = res.painel.identificacao;

                this.data.abrangencia = res.auxAbrangencia.selected;
                this.data.abrangenciaId = res.auxAbrangencia.selected.id;
                this.data.entidadeFinanciadora = res.auxEntidade.selected;
                this.data.entidadeFinanciadoraId = res.auxEntidade.selected.id;
                this.data.ambito = res.auxAmbito.selected;
                this.data.ambitoId = res.auxAmbito.selected.id;
                this.data.investigador = res.auxInvestigador.selected;
                this.data.investigadorId = res.auxInvestigador.selected.id;

                this.data.atualizadoPorId = this.user.id;
                this.data.atualizadoa = moment().format();

                this.Painel.upsert(this.data).$promise.then((res) => {
                  this.UI.addToast("Painel atualizado com sucesso");
                  this.loadData();
                }).catch((error) => {
                  console.log(error);
                  this.UI.showAlert("Erro ao atualizar painel. Verifique a ligação");
                  this.loaded = true;
                });
              }
            });
          }).catch((error) => {
            wait.close();
            console.log(error);
            this.UI.addToast("Não foi possível ler Abrangências. Verifique a ligação");
          });
        }).catch((error) => {
          wait.close();
          console.log(error);
          this.UI.addToast("Não foi possível ler Âmbitos. Verifique a ligação");
        });
      }).catch((error) => {
        wait.close();
        console.log(error);
        this.UI.addToast("Não foi possível ler Entidades. Verifique a ligação");
      });
    }).catch(error => {
      wait.close();
      console.log(error);
      this.UI.addToast("Não foi possível ler Investigadores. Verifique a ligação");
    });
  };

  editObservacoes = () => {
    let options = {
      size: 'lg',
      template: require('./observacoes.dialog.html'),
      controller: ['$scope', ($scope) => {
        $scope.label = "Editar Observações";
        $scope.observacoes = angular.copy(this.data.observacoes);

        $scope.ok = () => {
          $scope.$close($scope);
        };

        $scope.cancel = () => $scope.$dismiss('cancel');
      }]
    };

    this.UI.showDialog(options).then(ok => {
      this.loaded = false;
      if (ok.observacoes !== 0 && !ok.observacoes)
        ok.observacoes = null;
      this.data.observacoes = ok.observacoes;
      this.data.atualizadoPorId = this.user.id;
      this.data.atualizadoa = moment().format();
      this.Painel.upsert(this.data).$promise.then((res) => {
        this.UI.addToast("Observações atualizadas com sucesso");
        this.loadData();
      }).catch((error) => {
        console.log(error);
        this.UI.showAlert("Erro ao atualizar painel. Verifique a ligação");
        this.loaded = true;
      });
    });
  };

  // Permissions
  // read: (ownPermission, allowAll, adminPermission, users)
  // edit: (ownPermission, allowOwn, adminPermission, users)
  canReadGeneral = () => this.PainelService.canRead('painelRead', true, 'painelReadAny', this.PainelService.getInvestigadorUserId(this.data));
  canEditGeneral = () => this.PainelService.canEdit('painelEdit', true, 'painelEditAny', this.PainelService.getInvestigadorUserId(this.data));

  canReadAdicional = () => this.PainelService.canRead('painelReadAdicional', true, 'painelReadAdicionalAny', this.PainelService.getInvestigadorUserId(this.data));
  canEditAdicional = () => this.PainelService.canEdit('painelEditAdicional', true, 'painelEditAdicionalAny', this.PainelService.getInvestigadorUserId(this.data));

}

PainelDetailsController.$inject = ['$q', '$state', '$scope', 'AuthenticationService', 'UIService', 'PainelService', 'Painel', 'Abrangencia', 'Ambito', 'EntidadeFinanciadora', 'Investigador'];
